import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import AuthenticatedLink from 'ui/components/AuthenticatedLink';

export const ZoomIntegrationSection = withCustomComponent(
  'ZoomIntegrationSection'
)(
  inject(
    'appStore',
    'authStore'
  )(
    withRouter(
      observer(({ authStore, appStore, componentName }) => {
        const { t } = useTranslation();
        const { business, configuration } = appStore;
        const { customer } = authStore;
        return (
          <tr>
            <td className="py-16" valign="middle">
              <img src="/img/zoom_logo.png" />
            </td>
            <td className="w-100 pl-0 py-16" valign="middle">
              <h6 className="mb-4">{t('Zoom')}</h6>
              <p className="text-gray-700 fs-14 lh-14 mxw-500px mb-0">
                {t('Connecting to your Zoom account will enable you to create unique video conference links as you place bookings in the calendar.')}
              </p>
            </td>
            <td className="text-left text-md-right py-16" valign="middle">
              {customer?.HasZoom && (
                <AuthenticatedLink
                  href={`${business.NativeHomeUrlWithLanguage}/integrations/zoom/signout`}
                  className="btn btn-icon btn-gray-light "
                >
                  <i className="icon-disconnect"></i>
                  {t('Disconnect')}
                </AuthenticatedLink>
              )}
              {customer?.HasZoom === false && (
                <AuthenticatedLink
                  href={`${business.NativeHomeUrlWithLanguage}/integrations/zoom/signin`}
                  className="btn  mw-250px"
                >
                  {t('Connect to Zoom')}
                </AuthenticatedLink>
              )}
            </td>
          </tr>        
        );
      })
    )
  )
);
